module.exports = __webpack_public_path__ + "image/banner_technology.jpg";